import {
    ADDITIONAL_PACKAGES,
    BACK,
    CHANGE,
    CHANGE_TARIFF,
    CHANGE_TARIFF_WARNING,
    CHANNELS,
    CHANNELS_LIST,
    CHOOSE,
    CHOOSE_CITY,
    CHOOSE_FREE_PACKAGE_1,
    CHOOSE_FREE_PACKAGE_2,
    CHOOSE_FREE_PACKAGE_3,
    CHOOSE_MUNICIPALITY,
    CHOOSE_TARIFF_MODEL,
    CHOSEN,
    CHOSEN_ADDITIONAL_PACKAGES,
    CHOSEN_FREE_PACKAGES,
    CHOSEN_TARIFF_MODEL,
    INCLUDED_CHANNELS_IN_PACKAGE_1,
    INCLUDED_CHANNELS_IN_PACKAGE_2,
    INCLUDED_PACKAGES,
    INCLUDED_REGIONAL_CHANNELS,
    MKD,
    MKD_MONTHLY,
    ORDER,
    TARIFF_MODEL,
    TARIFF_TYPE,
    TOTAL_SUBSCRIPTION,
    INCLUDED_CHANNELS_IN_TARIFF,
    CHOOSE_CITY_MUNICIPALITY_TARIFF,
    CHOOSE_TARIFF,
    CHOOSE_FREE_PACKAGE_1_NEW,
    CHOOSE_FREE_PACKAGE_2_NEW,
    CHOOSE_FREE_PACKAGE_2_NEW_FREE,
    CHOOSE_FREE_PACKAGE_3_NEW,
    CHOOSE_FREE_PACKAGE_3_NEW_0_FREE_PACKAGES,
    CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM_LITE,
    CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM,
    PRICE_INCLUDE_VAT,
    DVBT_OFFER_CHANNELS,
    TV_CHANNELS,
    AVAILABLE
} from "./keys";

export const mkContent = [
    {
        key: CHOOSE_TARIFF_MODEL,
        value: 'Изберете еден од понудените тарифни модели'
    },
    {
        key: TARIFF_MODEL,
        value: 'Тарифен модел'
    },
    {
        key: TARIFF_TYPE,
        value: 'Тарифен тип'
    },
    {
        key: CHANNELS,
        value: 'Канали'
    },
    {
        key: CHANNELS_LIST,
        value: 'Листа на ТВ-канали'
    },
    {
        key: INCLUDED_PACKAGES,
        value: 'Вклучени ТВ-канали'
    },
    {
        key: CHOOSE_FREE_PACKAGE_1,
        value: 'ИЗБЕРЕТЕ'
    },
    {
        key: CHOOSE_FREE_PACKAGE_2,
        value: ' ОД СЛЕДНИТЕ ПАКЕТИ'
    },
    {
        key: CHOOSE_FREE_PACKAGE_3,
        value: 'кои може бесплатно да ги вклучите во избраната тарифа'
    },
    {
        key: ADDITIONAL_PACKAGES,
        value: 'Дополнителни пакети'
    },
    {
        key: CHOSEN,
        value: 'Одбрано'
    },
    {
        key: CHOSEN_TARIFF_MODEL,
        value: 'Избран тарифен модел'
    },
    {
        key: CHOSEN_FREE_PACKAGES,
        value: 'Избрани бесплатни пакети'
    },
    {
        key: CHOSEN_ADDITIONAL_PACKAGES,
        value: 'Избрани дополнителни пакети'
    },
    {
        key: TOTAL_SUBSCRIPTION,
        value: 'Вкупна претплата'
    },
    {
        key: ORDER,
        value: 'Нарачај'
    },
    {
        key: MKD_MONTHLY,
        value: 'ден./мес.'
    },
    {
        key: MKD,
        value: 'ден.'
    },
    {
        key: CHOOSE,
        value: 'Одбери'
    },
    {
        key: INCLUDED_CHANNELS_IN_PACKAGE_1,
        value: 'Вклучени канали во '
    },
    {
        key: INCLUDED_CHANNELS_IN_PACKAGE_2,
        value: ' пакетот'
    },
    {
        key: CHANGE_TARIFF,
        value: 'Промена на тарифа'
    },
    {
        key: CHANGE_TARIFF_WARNING,
        value: 'Со промена на тарифата ќе се избришат пакетите што веќе сте ги избрале. Дали сте сигурни дека сакате да ја промените тарифата?'
    },
    {
        key: CHANGE,
        value: 'Промени'
    },
    {
        key: BACK,
        value: 'Назад'
    },
    {
        key: CHOOSE_CITY,
        value: 'Одберете град'
    },
    {
        key: CHOOSE_MUNICIPALITY,
        value: 'Одберете општина'
    },
    {
        key: INCLUDED_REGIONAL_CHANNELS,
        value: 'Регионалните ТВ-канали се дополнителни и бесплатно вклучени во одбраната тарифа. Нивниот број зависи од регионот каде се користи услугата.'
    },
    {
        key:INCLUDED_CHANNELS_IN_TARIFF,
        value: 'Вклучени ТВ-канали во избраната тарифа'
    },
    {
        key: CHOOSE_CITY_MUNICIPALITY_TARIFF,
        value: 'За преглед на вклучени ТВ-канали одберете град, општина и тарифа'
    },
    {
        key: CHOOSE_TARIFF,
        value: 'Изберете тарифа'
    },
    {
        key:CHOOSE_FREE_PACKAGE_1_NEW,
        value: 'Со избраната тарифа'
    },
    {
        key:CHOOSE_FREE_PACKAGE_2_NEW,
        value: 'од следните ТВ пакети ги добивате '
    },
    {
        key:CHOOSE_FREE_PACKAGE_2_NEW_FREE,
        value: 'бесплатно.'
    },
    {
        key:CHOOSE_FREE_PACKAGE_3_NEW,
        value: 'Останатите ТВ-пакети може да ги активирате со наведените месечни претплати.'
    },
    {
        key:CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM_LITE,
        value: 'Пакетот HBO Premium Lite е достапен единствено со месечна претплата.'
    },
    {
        key:CHOOSE_FREE_PACKAGE_3_NEW_HBO_PREMIUM,
        value: 'Пакетот HBO Premium е достапен единствено со месечна претплата.'
    },
    {
        key:CHOOSE_FREE_PACKAGE_3_NEW_0_FREE_PACKAGES,
        value: 'ТВ пакети што може да ги активирате со наведените месечни претплати.'
    },
    {
        key:PRICE_INCLUDE_VAT,
        value: 'Сите наведени цени се со вклучен ДДВ.'
    },
    {
        key:DVBT_OFFER_CHANNELS,
        value: 'Понудата со наведениот број на ТВ-канали е достапна со оптичка или кабловска технологија. Доколку на Вашата локација нема техничка можност за овие технологии, тогаш ќе Ви биде понудена DVBT технологија за која се достапни следните'
    },
    {
        key: TV_CHANNELS,
        value: 'ТВ-канали'
    },
    {
        key: AVAILABLE,
        value: '.'
    }
];
